import { Box, Flex, Td, Tr, useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { BsPencil } from "react-icons/bs";
import DateTimeModal from "../Modals/DateTImeModal";
import { DateTime } from "luxon"
import { MdOutlineDeleteForever } from "react-icons/md";
import { DeleteReachoutModal } from "../Modals/DeleteReachoutModal";

export const ReachoutLogsTableRow = ({ el, func }: any) => {
  const {
    _id,
    template_id,
    filters,
    scheduled_date,
    scheduled_time,
    status,
    type,
    campaign_id,
    contacts_count,
  } = el;
  const { isOpen, onOpen, onClose } = useDisclosure();
  function isFiveMinutesOrLessLeft() {
    const target = DateTime.fromISO(`${scheduled_date}T${scheduled_time}`);
    const now = DateTime.now();

    const diffInMinutes: number =
      target.diff(now, "minutes").toObject().minutes || 0;

    return diffInMinutes <= 5;
  }

  const [modal, setModal] = useState("");
  return (
    <Tr>
      <Td
        px={2}
        borderBottom="1px solid gray"
        cursor={isFiveMinutesOrLessLeft() ? "not-allowed" : "pointer"}
      >
        <Box
          as="span"
          className="edit-icon"
          opacity={isFiveMinutesOrLessLeft() ? 0.5 : 1}
          onClick={() => {
            if (isFiveMinutesOrLessLeft()) return;
            onOpen();
            setModal("dateTimeModal");
          }}
        >
          <BsPencil />
        </Box>
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {/* <Box>{template_id}</Box> */}
        {template_id}
      </Td>

      <Td px={2} borderBottom="1px solid gray">
        {scheduled_date}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {scheduled_time}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {status}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {type}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {campaign_id}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {contacts_count}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {filters.status.join(", ")}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {filters.source.join(", ")}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {filters.languages_known.join(", ")}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {filters.gender.join(", ")}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {filters.age_group.join(", ")}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {filters.budget.join(", ")}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {filters.system_age.join(", ")}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        <span title="Delete">
          <MdOutlineDeleteForever
            className="deleteButton pointer"
            onClick={() => {
              setModal("deletemodal");
              onOpen();
            }}
          />
        </span>
      </Td>
      {modal === "dateTimeModal" && (
        <DateTimeModal
          templateId={template_id}
          id={_id}
          isOpen={isOpen}
          onClose={onClose}
          type={type}
          variableValues={[]}
          scheduledDate={scheduled_date}
          scheduledTime={scheduled_time}
          func={func}
        />
      )}
      {modal === "deletemodal" && (
        <DeleteReachoutModal
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={_id}
        />
      )}
    </Tr>
  );
};
